import React from 'react';
import classNames from 'classnames';

import './ProgressBar.scss';

// TODO: Update to TypeScript/TSX
const ProgressBar = ({ value, label, className, showOnBar, showOnRight, small }) => {
  const numberValue = value || value === 0 ? value : 0;
  const textValue = value || value === 0 ? `${value}%` : 'N/A';
  return (
    <>
      {label && <label>{label}</label>}
      <div className="praktio-progress-container">
        <div
          className={classNames('progress', 'praktio-progress', className, {
            small,
          })}
        >
          <div
            className={classNames('progress-bar')}
            role="progressbar"
            aria-valuenow={numberValue}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ width: `${numberValue}%` }}
          >
            {showOnBar && <span>{textValue}</span>}
            <span className="sr-only">{textValue}</span>
          </div>
        </div>
        {showOnRight && <div className="right-value">{textValue}</div>}
      </div>
    </>
  );
};

export default ProgressBar;
